/*
 * @创建文件时间: 2019-10-29 15:53:49
 * @最后修改人: lfq
 * @最后修改时间: 2019-11-13 17:08:33
 * @联系Qq:1638245306
 * @文件介绍: 
 */
import Vue from 'vue'
import Vuex from 'vuex'

import d2admin from './modules/d2admin'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        d2admin
    }
})